import Vue from "vue";
import { ActionContext, ActionTree } from "vuex";
import { CATEGORIAS } from "./types";
import { RootState } from "@/store/modules/general/types";
import { AxiosResponse } from "axios";

type CategoriasContext = ActionContext<CATEGORIAS, RootState>;
type CategoriasActionTree = ActionTree<CATEGORIAS, RootState>;

export const actions: CategoriasActionTree = {
  async listarCategorias(context: CategoriasContext, payload: any): Promise<any> {
    try {
      const response: AxiosResponse = await Vue.axios({
        method: "GET",
        url: "/Categoria/ListarCategorias",
        params: payload,
      });
      return response.data;
    } catch (error) {
      //Vacio, porque puede venir cualquier cosa.. :D
    }
  },
  async listarCategoriasArticulo(context: CategoriasContext, payload: any): Promise<any> {
    try {
      const response: AxiosResponse = await Vue.axios({
        method: "GET",
        url: "/Categoria/listarCategoriasArticulo",
        params: payload,
      });
      return response.data;
    } catch (error) {
      //Vacio, porque puede venir cualquier cosa.. :D
    }
  },
  async listarArticulos(context: CategoriasContext, payload: any): Promise<any> {
    try {
      const response: AxiosResponse = await Vue.axios({
        method: "GET",
        url: "/Articulo/ListarArticulos",
        params: payload,
      });
      return response.data;
    } catch (error) {
      //Vacio, porque puede venir cualquier cosa.. :D
    }
  },

  async listarArticulosFiltrado(context: CategoriasContext, payload: any): Promise<any> {
    try {
      const response: AxiosResponse = await Vue.axios({
        method: "GET",
        url: "/Articulo/listarArticulosFiltrado",
        params: payload,
      });
      return response.data;
    } catch (error) {
      //Vacio, porque puede venir cualquier cosa.. :D
    }
  },

  async postActualizaFavorito(context: CategoriasContext, payload: any): Promise<boolean>{
    try {
      const response: AxiosResponse = await Vue.axios({
        method: "POST",
        url: "/Articulo/ActualizaFavorito",
        data: payload,
      });
      return true;
    } catch (error) {
      console.log(error);
      return false;
      //Vacio, porque puede venir cualquier cosa.. :D
    }
  },
  async checkStock(context: CategoriasContext, payload: any): Promise<any> {
    try {
      const response: AxiosResponse = await Vue.axios({
        method: "POST",
        url: "/Articulo/CheckStock",
        data: payload,
      });
      return response.data;
    } catch (error) {
      //Vacio, porque puede venir cualquier cosa.. :D
    }
  },

  async GetConfig(context: CategoriasContext,): Promise<any> {
    try {
      const response: AxiosResponse = await Vue.axios({
        method: "GET",
        url: "/Articulo/getConfig",
      });
      return response.data;
    } catch (error) {
      //Vacio, porque puede venir cualquier cosa.. :D
    }
  },
};
